export default "__VITE_ASSET__D6MOj6TD__"